import React, {Fragment, useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import {serviceSingleStyles} from './styles';
import {
    AddButton,
    MinLoader,
    NameAndAvatar,
    PhoneBadge,
    EmailBadge,
    BadgeLine,
    UploadModal,
    UserInputsDropdown,
    SearchHistory,
    TagComponent,
    AddButtonLight,
    NavigateCalendar,
    CustomDelete, CustomBadge,
} from 'components';
import {
    Colors,
    FindLoad,
    Images,
    makeCapitalize,
    PermissionList,
    renderFirstLetters,
    renderStaffName,
    RolePermission,
    staffStatuses,
    tagEnums,
    useModal,
} from 'utils';
import {Popover} from '@mui/material';
import {CredentialModal} from 'fragments';
import {adminActions, systemActions} from 'store';
import {staffStatus} from './constants';
import {TimeSheetModalSelector} from '../../modals';
import {PaycodeModal, AssignZoomModal} from './modals';
import {TELEHEALTH_PROVIDERS} from '../../../schedule/constants';

// const IS_CLINICIAN = 'IS_CLINICIAN';
const STATUS_ACTION_TYPE = 'CHANGE_ADMIN_STATUS';
const TELEHEALTH_STATUS_ACTION_TYPE = 'CHANGE_TELEHEALTH_STATUS';
export const StaffItemHeader = ({}) => {
    const {adminInfoById, zoomConnection, googleMeetConnection} = useSelector((state) => ({
        adminInfoById: state.admins.adminInfoById,
        zoomConnection: state.system.zoomConnection,
        googleMeetConnection: state.system.googleMeetConnection,
    }));
    const activeEmployment = adminInfoById?.employment;
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const classes = serviceSingleStyles();
    const dispatch = useDispatch();
    const loadReinvite = FindLoad('REINVITE_ADMIN');
    const {open} = useModal();
    const loadTelehealthStatus = FindLoad(TELEHEALTH_STATUS_ACTION_TYPE);
    const [telehealthAnchorEl, setTelehealthAnchorEl] = useState(null);
    const telehealthPopoverOpen = Boolean(telehealthAnchorEl);

    const telehealthProvider = googleMeetConnection?.isConnected
        ? TELEHEALTH_PROVIDERS.GOOGLE_MEET
        : zoomConnection?.isConnected
            ? TELEHEALTH_PROVIDERS.ZOOM
            : null;

    useEffect(() => {
        dispatch(systemActions.getTelehealthStatus());
    }, []);

    const reinvite = () => {
        dispatch(adminActions.reinviteAdmin(adminInfoById?.id));
    };

    const handleChangeStatus = (params) => {
        dispatch(adminActions.changeAdminStatus(adminInfoById.id, params));
    };

    const handleTelehealthClick = (e) => {
        if (adminInfoById?.telehealth?.active) {
            setTelehealthAnchorEl(e.currentTarget);
        } else if (telehealthProvider === TELEHEALTH_PROVIDERS.ZOOM) {
            open(<AssignZoomModal staffId={adminInfoById?.id}/>);
        } else if (telehealthProvider === TELEHEALTH_PROVIDERS.GOOGLE_MEET) {
            open(
                <CustomDelete
                    text="Enable telehealth for this staff? They will be able to host Google Meet sessions."
                    info="Enable Telehealth"
                    handleDel={() => dispatch(adminActions.changeTelehealthStatus(adminInfoById.id, true))}
                    actionType={TELEHEALTH_STATUS_ACTION_TYPE}
                    innerText={'Enable'}
                    color={'blue'}
                />,
            );
        }
    };

    const handleDisableTelehealth = () => {
        setTelehealthAnchorEl(null);
        dispatch(adminActions.changeTelehealthStatus(adminInfoById.id, false));
    };

    const handleChangeZoomAccount = () => {
        setTelehealthAnchorEl(null);
        open(<AssignZoomModal staffId={adminInfoById?.id}/>);
    };

    return (
        <Fragment>
            <div className="tabs-wrapper">
                <div className="full-width">
                    <div className="space-between-flex-start">
                        <NameAndAvatar
                            src={adminInfoById?.avatar?.url}
                            name={renderStaffName(adminInfoById)}
                            initials={renderFirstLetters(adminInfoById)}
                        >
                            <div className='flex-align-center' style={{gap: 12}}>
                                {activeEmployment?.title?.name &&
                                    <CustomBadge text={activeEmployment?.title?.name} icon={Images.staffPosition}/>
                                }
                                {adminInfoById?.phone &&
                                    <PhoneBadge phone={adminInfoById?.phone}/>
                                }
                                {adminInfoById?.email &&
                                    <EmailBadge email={adminInfoById?.email}/>
                                }

                                <BadgeLine/>

                                <TagComponent
                                    userInfo={adminInfoById}
                                    module={tagEnums.STAFF}
                                    singleView
                                    doNotCropTags
                                    maxTags={null}
                                    notSetText={'No tags added'}
                                />
                            </div>
                        </NameAndAvatar>

                        <div className="flex-align-start" style={{gap: 16}}>
                            {RolePermission([PermissionList.STAFF_CREATE?.code]) && !!telehealthProvider && (
                                <>
                                    {loadTelehealthStatus?.length ? (
                                        <div className={`view-calendar-detail-btn ${classes.telehealthBtnLoader}`}>
                                            <MinLoader position={'relative'} margin={'0'} color={Colors.ThemeBlue}/>
                                        </div>
                                    ) : (
                                        <button
                                            onClick={handleTelehealthClick}
                                            className={`view-calendar-detail-btn ${classes.telehealthBtn}`}
                                        >
                                            <img src={Images.videos} alt="telehealth"/>
                                            <span>Telehealth</span>
                                            {adminInfoById?.telehealth?.active &&
                                                <span className={classes.telehealthActiveDot}/>}
                                        </button>
                                    )}

                                    <Popover
                                        open={telehealthPopoverOpen}
                                        anchorEl={telehealthAnchorEl}
                                        onClose={() => setTelehealthAnchorEl(null)}
                                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                                        transformOrigin={{vertical: 'top', horizontal: 'right'}}
                                        PaperProps={{className: classes.telehealthPopoverPaper}}
                                    >
                                        <div className="zoom-in-use-wrapper">
                                            {telehealthProvider === TELEHEALTH_PROVIDERS.ZOOM ? (
                                                <>
                                                    <div className={classes.telehealthPopoverHeader}>
                                                        <img
                                                            style={{
                                                                filter: 'brightness(0) saturate(100%) invert(30%) sepia(37%) saturate(3749%) hue-rotate(203deg) brightness(95%) contrast(104%)',
                                                            }}
                                                            src={Images.videos}
                                                            alt="zoom"
                                                        />
                                                        <p>Zoom account in use</p>
                                                    </div>
                                                    <div className={classes.telehealthPopoverUser}>
                                                        <div className={classes.telehealthPopoverAvatar}>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="12"
                                                                height="13"
                                                                viewBox="0 0 12 13"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M11.0315 12.3268V11.0305C11.0315 10.3429 10.7584 9.68349 10.2722 9.19729C9.78595 8.71108 9.12651 8.43794 8.43891 8.43794H3.25373C2.56613 8.43794 1.90669 8.71108 1.42049 9.19729C0.93428 9.68349 0.661133 10.3429 0.661133 11.0305V12.3268M8.43891 3.25275C8.43891 4.6846 7.27817 5.84534 5.84632 5.84534C4.41447 5.84534 3.25373 4.6846 3.25373 3.25275C3.25373 1.8209 4.41447 0.660156 5.84632 0.660156C7.27817 0.660156 8.43891 1.8209 8.43891 3.25275Z"
                                                                    stroke="white"
                                                                    stroke-width="1.32222"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                            </svg>
                                                        </div>
                                                        <div>
                                                            <p className={classes.telehealthPopoverUserName}>
                                                                {adminInfoById?.telehealth?.zoomUserName}
                                                            </p>
                                                            <p className={classes.telehealthPopoverUserEmail}>
                                                                {adminInfoById?.telehealth?.zoomUserEmail}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className={classes.telehealthPopoverActions}>
                                                        <span onClick={handleChangeZoomAccount}
                                                              className={classes.telehealthChangeAccount}>
                                                            Change account
                                                        </span>
                                                        <span onClick={handleDisableTelehealth}
                                                              className={classes.telehealthDisable}>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M8.88325 4.16536H11.6666C12.1086 4.16536 12.5325 4.34096 12.8451 4.65352C13.1577 4.96608 13.3333 5.39 13.3333 5.83203V8.61537L14.1666 9.4487L19.1666 5.83203V14.1654M0.833252 0.832031L19.1666 19.1654M13.3333 13.332V14.1654C13.3333 14.6074 13.1577 15.0313 12.8451 15.3439C12.5325 15.6564 12.1086 15.832 11.6666 15.832H2.49992C2.05789 15.832 1.63397 15.6564 1.32141 15.3439C1.00885 15.0313 0.833252 14.6074 0.833252 14.1654V5.83203C0.833252 5.39 1.00885 4.96608 1.32141 4.65352C1.63397 4.34096 2.05789 4.16536 2.49992 4.16536H4.16659L13.3333 13.332Z"
                                                                    stroke="#475467"
                                                                    stroke-width="1.67"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                            </svg>
                                                            Disable telehealth
                                                        </span>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className={classes.telehealthPopoverHeader}>
                                                        <img
                                                            src={Images.googleMeet}
                                                            alt="google-meet"
                                                            style={{width: 20, height: 20}}
                                                        />
                                                        <p>Google Meet enabled</p>
                                                    </div>
                                                    <div className={classes.telehealthPopoverActions}>
                                                        <span onClick={handleDisableTelehealth}
                                                              className={classes.telehealthDisable}>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M8.88325 4.16536H11.6666C12.1086 4.16536 12.5325 4.34096 12.8451 4.65352C13.1577 4.96608 13.3333 5.39 13.3333 5.83203V8.61537L14.1666 9.4487L19.1666 5.83203V14.1654M0.833252 0.832031L19.1666 19.1654M13.3333 13.332V14.1654C13.3333 14.6074 13.1577 15.0313 12.8451 15.3439C12.5325 15.6564 12.1086 15.832 11.6666 15.832H2.49992C2.05789 15.832 1.63397 15.6564 1.32141 15.3439C1.00885 15.0313 0.833252 14.6074 0.833252 14.1654V5.83203C0.833252 5.39 1.00885 4.96608 1.32141 4.65352C1.63397 4.34096 2.05789 4.16536 2.49992 4.16536H4.16659L13.3333 13.332Z"
                                                                    stroke="#475467"
                                                                    stroke-width="1.67"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                            </svg>
                                                            Disable telehealth
                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </Popover>
                                </>
                            )}

                            <NavigateCalendar staff={adminInfoById} full={true}/>
                            {RolePermission([PermissionList.STAFF_STATUS?.code]) && (
                                <UserInputsDropdown
                                    dropdownOptions={staffStatuses}
                                    actionType={STATUS_ACTION_TYPE}
                                    selected={adminInfoById?.status}
                                    onPass={handleChangeStatus}
                                    type={'Staff'}
                                />
                            )}
                            {(!info?.activeTab || info?.activeTab === 'General') &&
                                adminInfoById?.authStatus !== staffStatus?.ACTIVE &&
                                RolePermission([PermissionList.STAFF_CREATE.code]) && (
                                    <button className={classes.reinvite} onClick={reinvite}>
                                        {loadReinvite?.length ? (
                                            <MinLoader margin={'0'} color={Colors.TextWhite} position={'relative'}/>
                                        ) : (
                                            <>
                                                <img src={Images.reinvite} alt="icon"/>
                                                <p>Reinvite</p>
                                            </>
                                        )}
                                    </button>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
